// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-edit {
  display: block;
  height: 100%;
  background-color: var(--fi-background-color-extra-light);
  overflow-y: auto;
}
.fi-task-edit .fi-task-edit-task {
  max-width: 750px;
  display: block;
  padding: 20px 5px 5px;
  margin: auto;
}
.fi-task-edit .fa {
  color: var(--fi-color-light);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-task-shared/task-edit/task-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;EACA,wDAAA;EACA,gBAAA;AACJ;AAAI;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;AAER;AACI;EACI,4BAAA;AACR","sourcesContent":[".fi-task-edit {\r\n    display: block;\r\n    height: 100%;\r\n    background-color: var(--fi-background-color-extra-light);\r\n    overflow-y: auto;\r\n    .fi-task-edit-task {\r\n        max-width: 750px;\r\n        display: block;\r\n        padding: 20px 5px 5px;\r\n        margin: auto;\r\n    }\r\n\r\n    .fa {\r\n        color: var(--fi-color-light);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
